import script from "./AddMiddleMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddMiddleMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AddMiddleMenu.vue?vue&type=style&index=0&id=f14058b4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f14058b4"]])

export default __exports__